import { HolidayWindow, TimeWindow } from '@provision/sidekick-utils';

export enum PartnerBusinessState {
  Open = 'open',
  Closed = 'closed',
  Holiday = 'holiday',
}

export interface PartnerBusinessStatus {
  isLoaded: boolean;
  state: PartnerBusinessState;
  currentTime: Date;
  /** The closure covering right now, when the partner is closed for a holiday. */
  activeHoliday: HolidayWindow | null;
  /** A closure that has not started yet: later today, or on the next day the partner would open. */
  upcomingHoliday: HolidayWindow | null;
  /** When that closure interrupts business — used to name the day in the heads-up. */
  upcomingHolidayAt: Date | null;
  upcomingReopensAt: Date | null;
  openUntil: Date | null;
  opensAt: Date | null;
  weeklyHours: TimeWindow[];
  timeZone?: string;
}
